import React from "react";

export const ConfidentialityPersonalDataOptIn = () => {
  return (
    <div>
      <strong>Oui, j’accepte de recevoir</strong> les communications par email et/ou SMS{" "}
      <strong>pour m’aider à optimiser mes charges et/ou développer mon patrimoine</strong>
    </div>
  );
};
